import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { Heart, Globe } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../components/ui/dropdown-menu';
import { Button } from '../components/ui/button';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'mr', label: 'मराठी' },
];

export default function Footer() {
  const { t, lang, setLanguage } = useLanguage();

  return (
    <footer className="bg-[#2D2424] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Heart className="w-6 h-6 text-[#D9381E] fill-[#D9381E]" />
              <span className="text-lg font-bold">Vivah<span className="text-[#D9381E]">Rang</span></span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-[#F2A900]">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/" className="hover:text-white transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/search" className="hover:text-white transition-colors">{t('nav.search')}</Link></li>
              <li><Link to="/plans" className="hover:text-white transition-colors">{t('nav.plans')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-[#F2A900]">Legal</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><a href="#" className="hover:text-white transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('footer.terms')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('footer.refund')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-[#F2A900]">{t('footer.contact')}</h4>
            <p className="text-sm text-white/60 mb-3">{t('footer.helpline')}</p>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="border-white/20 text-white hover:bg-white/10 bg-transparent gap-2">
                  <Globe className="w-4 h-4" />
                  {languages.find(l => l.code === lang)?.label}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {languages.map(l => (
                  <DropdownMenuItem key={l.code} onClick={() => setLanguage(l.code)} data-testid={`footer-lang-${l.code}`}>
                    {l.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center">
          <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} VivahRang. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
}
